import { AxiosError } from 'axios'
import { CustomEvents } from 'shared/constants/customEvents'
import { dispatchCustomEvent } from 'shared/utils/customEvents'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const onLoginError = (error: AxiosError<any>) => {
  const errors = error.response?.data?.error ?? {}
  const errorKeys = Object.keys(errors)
  if (errorKeys.includes('otp')) {
    dispatchCustomEvent(CustomEvents.AUTH_LOGIN_REQUIRES_OTP, {
      mobileApprovalSessionId: error.response?.data?.data?.session_uuid ?? null
    })
  }
}
